import React from 'react';
import "./SaveOnParts.css";

import manOnBike from "../images/manOnbike.png"

export const SaveOnParts = () => {
    return (
    <aside className="sidebar-container">
        <section className="sidebar-container__textContainer">
            <h2 className="sidebar-container__textContainer-title">Save on <br /> Multi-parts</h2>

            <p className="sidebar-container__textContainer-paragraph">  Check my full service with amazing features ALL individual jobs are included as is fitting of any and all extra part or accessories required/requested, Eg pedals, mudguards, lights etc
            </p>


            <h2 className="sidebar-container__textContainer-title">
                at just £145
            </h2>

            <p className="sidebar-container__textContainer-paragraph">
                Getting your bike serviced regularly is by far the most economical way of maintaining it
            </p>
        </section>
        <img className="sidebar-container-image" src={manOnBike} alt="" />
    </aside>
    )
}
